export default "__VITE_PUBLIC_ASSET__b196dcb7__"